function resolveItemColors(theme, ownerState) {
  const { palette, functions } = theme;
  const { transparentSidenav, whiteSidenav, darkMode, active, sidenavColor } = ownerState;

  const { white, transparent, dark, grey, gradients } = palette;
  const { rgba, linearGradient } = functions;

  const text =
    (transparentSidenav && !darkMode && !active) || (whiteSidenav && !active)
      ? dark.main
      : white.main;

  const bg = active
    ? linearGradient(gradients[sidenavColor].main, gradients[sidenavColor].state)
    : transparent.main;

  const hover = !active
    ? transparentSidenav && !darkMode
      ? grey[200]
      : rgba(whiteSidenav ? grey[400] : white.main, whiteSidenav ? 0.18 : 0.12)
    : undefined;

  return { text, bg, hover };
}

function resolveIconColor(theme, ownerState) {
  const { palette, functions } = theme;
  const { transparentSidenav, whiteSidenav, darkMode, active } = ownerState;
  const { white, dark, text } = palette;
  const { rgba } = functions;

  if (active) return white.main;
  if (transparentSidenav && !darkMode) return text.main;
  if (whiteSidenav) return dark.main;
  return rgba(white.main, 0.9);
}

function collapseItem(theme, ownerState) {
  const { transitions, breakpoints, boxShadows, borders, functions } = theme;
  const { active, whiteSidenav, darkMode, transparentSidenav, locked } = ownerState;

  const { md } = boxShadows;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  const { text, bg, hover } = resolveItemColors(theme, ownerState);

  const showShadow = active && !whiteSidenav && !darkMode && !transparentSidenav;

  return {
    background: bg,
    color: text,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    zIndex: 1300, // MUI modal(1300) seviyesine yakın/üst
    isolation: 'isolate', // kendi stacking context
    transform: 'translateZ(0)', // GPU layer (3D hissi + stacking stabil)
    // ✅ daha minimal / sıkı
    padding: `${pxToRem(6)} ${pxToRem(10)}`,
    margin: `${pxToRem(1)} ${pxToRem(12)}`,
    borderRadius: borderRadius.md,

    cursor: locked ? 'not-allowed' : 'pointer',
    userSelect: 'none',
    whiteSpace: 'nowrap',

    boxShadow: showShadow ? md : 'none',
    opacity: locked ? 0.6 : 1,
    pointerEvents: locked ? 'none' : 'auto',

    [breakpoints.up('xl')]: {
      transition: transitions.create(['box-shadow', 'background-color'], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },

    '&:hover, &:focus-visible': locked
      ? {}
      : {
          backgroundColor: hover,
        },
  };
}

function collapseIconBox(theme, ownerState) {
  const { transitions, borders, functions } = theme;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  const iconColor = resolveIconColor(theme, ownerState);

  return {
    // ✅ daha küçük icon kutusu
    minWidth: pxToRem(30),
    minHeight: pxToRem(30),
    borderRadius: borderRadius.md,
    display: 'grid',
    placeItems: 'center',
    color: iconColor,

    transition: transitions.create('margin', {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    '& svg, svg g': {
      color: iconColor,
    },
  };
}

const collapseIcon = (theme, ownerState) => ({
  color: resolveIconColor(theme, ownerState),
});

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { miniSidenav, transparentSidenav, active } = ownerState;

  const { size, fontWeightRegular, fontWeightLight } = typography;
  const { pxToRem } = functions;

  const isMini = miniSidenav || (miniSidenav && transparentSidenav);

  return {
    marginLeft: pxToRem(8),

    [breakpoints.up('xl')]: {
      opacity: isMini ? 0 : 1,
      maxWidth: isMini ? 0 : '100%',
      marginLeft: isMini ? 0 : pxToRem(8),
      transition: transitions.create(['opacity', 'margin', 'max-width'], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    '& span': {
      fontWeight: active ? fontWeightRegular : fontWeightLight,
      fontSize: size.sm,
      lineHeight: 1.15,
      letterSpacing: 0, // ✅ daha sıkı
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };
